var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-title',[_c('h1',[_vm._v("Anfrage gesendet")])]),_c('v-card-text',[_c('span',[_vm._v("Ihre Daten wurden übermittelt. Ein Mitarbeiter wird sich schnellstmöglich mit Ihnen in Verbindung setzen. ")])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }